<div class="mb-3 border-0">
  <div class="card d-flex flex-row border rounded-2 shadow-sm overflow-hidden" style="min-height: 100px">

    <!-- Icona a sinistra -->
    <div class="d-flex align-items-center justify-content-center flex-shrink-0" [ngClass]="{
      'bg-primary text-white': !attachment.signed || (attachment.signed && attachment.isFirstSignedOfType),
      'bg-light text-danger': attachment.signed && !attachment.isFirstSignedOfType
      }" style="width: 60px;">
      <ng-container *ngIf="attachment.transitionFormId">
        <it-icon *ngIf="attachment.signed && attachment.isFirstSignedOfType" name="file-pdf-ext"
          color="light"></it-icon>
        <it-icon *ngIf="attachment.signed && !attachment.isFirstSignedOfType" name="ban" color="primary"></it-icon>
        <it-icon *ngIf="!attachment.signed" name="check-circle" color="light"></it-icon>
      </ng-container>

      <it-icon *ngIf="!attachment.transitionFormId" name="clip" color="light"></it-icon>
    </div>


    <!-- Contenuto e bottoni -->
    <div class="flex-grow-1 d-flex flex-row p-3">

      <!-- Colonna testo -->
      <div class="flex-grow-1 d-flex flex-column justify-content-between">
        <div>
          <div class="fw-semibold">{{ attachment.type.name }}</div>
          <div class="text-muted small mb-2">{{ attachment.name }}</div>
        </div>

        <div class="text-muted small mt-2" *ngIf="attachment.document?.uploadDate">
          Caricato il: <span class="fw-semibold">{{ attachment.document.uploadDate | date: 'dd/MM/yyyy HH:mm' }}</span>
        </div>
      </div>

      <div class="d-flex align-items-center ps-3 flex-shrink-0 text-end">
        <div class="d-flex gap-2 flex-wrap justify-content-end">
          <button *ngIf="canDelete" itButton="danger" size="xs" (click)="removeAttachment()">
            Rimuovi
          </button>
          <button itButton="outline-primary" size="xs" (click)="downloadAttachment()">
            Scarica
          </button>
        </div>
      </div>

    </div>
  </div>
</div>